import { useState } from 'react';

function ReachUsForm() {
    const [form, setForm] = useState({
        name: '',
        contact: '',
        email: '',
        address: '',
    });

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const message = `Hello RP Smart Energy,%0A
*REACH US ENQUIRY*%0A
Name: ${form.name}%0A
Contact: ${form.contact}%0A
Email: ${form.email}%0A
Address: ${form.address}`;

        const whatsappURL = `https://api.whatsapp.com/send?phone=919994356072&text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };

    return (
        <div className="container mt-5">
            <div className="row">
                
                <div className="col-md-8">
                    <h2 className="mb-4">Reach Us</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3">
                            <label className="form-label">Name</label>
                            <input type="text" className="form-control" name="name" onChange={handleChange} required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Contact Number</label>
                            <input type="text" className="form-control" name="contact" onChange={handleChange} required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Email ID</label>
                            <input type="email" className="form-control" name="email" onChange={handleChange} required />
                        </div>
                        <div className="mb-3">
                            <label className="form-label">Address</label>
                            <textarea className="form-control" name="address" rows="3" onChange={handleChange} required></textarea>
                        </div>
                        <button type="submit" className="btn btn-success">Submit</button>
                    </form>
                </div>

               
                <div className="col-md-4 mt-4 mt-md-0">
                    <h5 className="mb-3">Our Location</h5>
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3911.8453356947957!2d77.60030927486561!3d11.346005288839526!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba96dfdb96e5ce1%3A0x98b4f317d24ef86e!2sRP%20SMART%20ENERGY!5e0!3m2!1sen!2sin!4v1721815178808!5m2!1sen!2sin"
                        className="rounded"
                        width="100%"
                        height="400"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="RP Smart Energy Location"
                    ></iframe>
                </div>
            </div>
        </div>
    );
}

export default ReachUsForm;